import React from 'react';
import { useSoftLoading } from './SoftLoadingContext';
import './SoftLoader.scss';

// Thin top-bar progress indicator for small/background API calls.
// Unlike GlobalLoader it never dims or blocks the page — pointer-events
// pass straight through — so the user can keep interacting while it's up.
const SoftLoader = () => {
  const { isSoftLoading } = useSoftLoading();

  if (!isSoftLoading) return null;

  return (
    <div className="sl-bar-track" role="status" aria-label="Loading" aria-live="polite">
      <div className="sl-bar-fill" />
    </div>
  );
};

export default SoftLoader;
